
/**
 *
 */
const style = (t) => {
    const { colors, typography } = t['foundations-library']
    const colorsMap = { // I know but the design is funky
        primary: {
            base: {
                bg: colors.primary[50],
                color: colors.primary[500]
            },
            hover: {
                bg: 'rgba(170, 219, 160, 0.7)'
            },
            active: {
                bg: colors.secondary[500]
            }
        },
        neutral: {
            base: {
                bg: colors.neutral[50],
                color: colors.neutral[700]
            },
            active: {
                bg: colors.neutral[900]
            }
        }
    }
    return {
        tab: {
            height: '44px',
            borderRadius: '30px',
            padding: '10.5px 20px',
            backgroundColor: ({ color }) => colorsMap?.[color]?.base?.bg || colors[color][50],
            color: ({ color }) => colorsMap?.[color]?.base?.color || colors[color][500],
            width: '100%',
            ...typography.subtitle1,
            '&:hover': { backgroundColor: ({ color }) => colorsMap?.[color]?.hover?.bg || colors[color][200] },
            '&.active--tab': {
                backgroundColor: ({ color }) => colorsMap?.[color]?.active?.bg || colors[color][500],
                color: ({ color }) => colorsMap?.[color]?.active?.color || 'white'
            },
            '& .tab--icon': {
                marginRight: '6px'
            },
            '& .tab--icon-right': {
                marginLeft: '6px',
                marginRight: '0'
            },
            '& .tab--notification': {
                marginLeft: '6px'
            },
            '@media (max-width: 600px)': { // https://www.figma.com/design/ReMoz06UzThiFEOUdj25jS/PayMyBill?node-id=2633-21615&t=KjSeqHwg8k7EpuCi-4
                fontSize: '12px',
                lineHeight: '12px',
                height: '37px',
                display: 'inline-flex',
                justifyContent: 'center',
                alignItems: 'center',
                whiteSpace: 'nowrap',
                padding: '6px 17px'
            }
        }
    }
}

export default style
